import React, { useMemo } from "react"
import { Box, Typography, Divider } from "@material-ui/core"
import PropTypes from "prop-types"

import styles from "./styles"

const CrewBillingTotal = ({ data = {}, originalOnly = false }) => {
  const classes = styles()

  const originalTotal = useMemo(() => {
    let newArray = []
    if (data) {
      data.expenses.map(y => {
        newArray = [...newArray, y.quantity * y.actual_rate]
      })
    }
    return newArray.reduce((partial_sum, a) => partial_sum + a, 0)
  })

  const additionalTotal = useMemo(() => {
    let newArray = []
    if (data) {
      data.additional_expenses.map(y => {
        newArray = [...newArray, y.quantity * y.actual_rate]
      })
    }
    return newArray.reduce((partial_sum, a) => partial_sum + a, 0)
  })

  const finalTotal = originalTotal + additionalTotal

  if (originalOnly) {
    return (
      <Box>
        <Box className={classes.totalBox}>
          <Typography className={classes.blueTitles}>ORIGINAL TOTAL</Typography>
        </Box>
        <Box className={classes.totalNumberBox}>
          <Typography className={classes.font}>
            {"$ " +
              originalTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </Typography>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      <Box className={classes.totalBox}>
        <Typography className={classes.blueTitles}>ADDITIONAL TOTAL</Typography>
        {/* <InfoIcon
            style={{ color: "#000000", opacity: "0.3", fontSize: "14px" }}
          /> */}
      </Box>
      <Box className={classes.totalNumberBox}>
        <Typography className={classes.font}>
          {"$ " +
            additionalTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </Typography>
      </Box>
      <Box className={classes.dataRow}>
        <Typography className={classes.blueTitles}>ORIGINAL TOTAL</Typography>
        <Typography className={classes.font}>
          {"$ " + originalTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </Typography>
      </Box>
      <Divider />
      <Box className={classes.dataRow}>
        <Typography className={classes.blueTitles}>FINAL TOTAL</Typography>
        <Typography className={classes.font}>
          {"$ " + finalTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </Typography>
      </Box>
    </Box>
  )
}

CrewBillingTotal.propTypes = {
  data: PropTypes.object,
  originalOnly: PropTypes.bool,
}

export default CrewBillingTotal
